import React from 'react';

export const TargetIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <path
            d="M10.77 11.9l3.087-2.963M13.857 8.937l.42-2.667L16.685 4l.372 1.866L19 6.223l-2.365 2.31-2.778.404z"
            stroke="currentColor"
            strokeWidth=".7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.207 10.232c.393 1.428.3 2.94-.265 4.314a7.007 7.007 0 01-2.877 3.325 7.46 7.46 0 01-4.37 1.044 7.386 7.386 0 01-4.164-1.644 6.893 6.893 0 01-2.341-3.692 6.676 6.676 0 01.392-4.306 7.031 7.031 0 012.973-3.246 7.47 7.47 0 014.399-.925"
            stroke="currentColor"
            strokeWidth=".7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.997 11.102c.195.754.14 1.548-.157 2.27a3.77 3.77 0 01-1.502 1.762c-.68.423-1.48.631-2.288.597a3.989 3.989 0 01-2.224-.789 3.733 3.733 0 01-1.334-1.881 3.592 3.592 0 01.051-2.275 3.752 3.752 0 011.418-1.824 4.002 4.002 0 012.258-.695"
            stroke="currentColor"
            strokeWidth=".7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
